export class ContactGroupPayload
{
    public name: string;
    public type: 'group' | 'contacts';
    public parent_id?: number;

    constructor() {}
}